import { render, staticRenderFns } from "./ModalCancelarImportacaoBeneficiario.vue?vue&type=template&id=25c55f7e"
import script from "./ModalCancelarImportacaoBeneficiario.vue?vue&type=script&lang=js"
export * from "./ModalCancelarImportacaoBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelarImportacaoBeneficiario.vue?vue&type=style&index=0&id=25c55f7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports